module.exports = __webpack_public_path__ + "img/48600.ed9cfce1.jpg";